import { useRouter } from 'next/router';
import { useMemo } from 'react';

import Crumb from './Crumb';

import { deSlugify, titleCase } from './utils';

import styles from './Breadcrumbs.module.scss';

import type { BreadcrumbsProps } from './types';

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ setRouteList }) => {
  const router = useRouter();

  const routeList = useMemo(() => {
    if (router.pathname === '/') {
      return [];
    }

    const [pathWithoutQuery] = router.asPath.split('?');

    const linkPath = pathWithoutQuery.split('/');

    const list = linkPath.map((route, index) => {
      if (route === '') {
        return {
          href: '/',
          name: 'Home',
        };
      }

      return {
        href: linkPath
          .slice(0, index + 1)
          .join('/')
          .replace(/(\?|#).*/, ''),
        name: titleCase(deSlugify(route)),
      };
    });

    return setRouteList ? setRouteList(list) : list;

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setRouteList]);

  if (!routeList.length) {
    return null;
  }

  return (
    <nav aria-label="Breadcrumb" className={styles.container}>
      <ol>
        {routeList.map((route, index) => {
          const isLast = index === routeList.length - 1;

          return (
            <Crumb
              key={index}
              route={route}
              isActive={isLast}
              aria-current={isLast ? 'page' : undefined}
              showArrow={index !== 0}
            />
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
